// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-I":"I_power-ocean-home-I__XzDpV"};